import React, {useEffect, useState, Fragment} from 'react'
import { matchTemplateFieldWithValue, initialValue } from '../../lib/utils';
import {VisDiv, ViewLabelValueField,  RegisterTemplateData, FieldDropdown, NewDeviceField} from '../../components';
import { addValueForDropdown, sortByLabel, expandReference, translatedLabel } from '../../lib/utils'; 
import {useStateContext} from '../../context/StateContext';
import { trackDoc } from '../RegisterTemplateData';
import TestButton from './TestButton';



/**
 * This function renders a field to edit the presidio of a device
 * #deviceFields
 * #devices
 * #core
 * @param {string} label - the label of the field
 * @param {object} registerTemplate - the register template of the device
 * @param {function} setChangingPresidio - a hook to set a boolean indicating if the device is being edited
 * @param {object} device - the device being edited
 * @param {object} template - the template of the device
 * @param {object} trackedChanges - the array of changed fields
 * @param {function} setTrackedChanges - a hook to add or edit to the array of changed fields
 * @param {function} setTemplateDevice - a hook to set the register template of the device
 * @param {object} templateDevice - the register template of the device
 * @param {boolean} deviceEdit - a boolean indicating if the device is being edited
 * @param {boolean} isError - a boolean indicating if there is an error
 * @param {string} errorMessage - a string indicating the error message
 * @param {boolean} isDuplicate - a boolean indicating if the device is a duplicate
 * @param {boolean} substitute - a boolean indicating if the device is being substituted
 */
export const ViewEditPresidio = ({label, registerTemplate, setChangingPresidio=()=>{}, device, template, trackedChanges, setTrackedChanges, setTemplateDevice, templateDevice, deviceEdit, isError, errorMessage, isDuplicate, substitute }) => {
    const testing = false;

    const [presidioInitialValue, setPresidioInitialValue] = useState(undefined);
    const [subPresidioInitialValue, setSubPresidioInitialValue] = useState(undefined);
    
    /**
     * #devicesFields
     * Returns the initial value of the device to be edited.
     * If the device is a substitute, it returns the value of the substitute device.
     * If the device is not a substitute, it returns the value of the device.
     * If the device or template device do not exist, it returns undefined.
     * @returns {object} - the initial value of the device to be edited
     */
    const initialValueDoc = () => {
        //console.log("begin initialValueDoc nlkwjcnlkeswjc", device, templateDevice)
        if (!device && !templateDevice) {
            return undefined;
        }
        
        if (device && substitute) {
            const substituteDevice = expandReference(device.substituteDevice, template.devices);
            //console.log("oijdiwdjoaiwsjd is initial value doc", {device, substituteDevice})
            if (!device?.substituteDevice) {
                return {...device, label: templateDevice?.label, value: templateDevice?.label};
            }
            return {...device, label: substituteDevice?.label, value: substituteDevice?.label};
        }
        
        if (device) {
            //console.log("oijdiwdjoaiwsjd is initial value doc", {device, templateDevice})
            return {...device, label: templateDevice?.label, value: templateDevice?.label};
        }
      
        
        return undefined;
    };

   const consoleData = {
        presidioInitialValue, 
        subPresidioInitialValue, 
        device,
        templateDevice,
        label,
        initialValueDoc: initialValueDoc()
    }
     // it is used to set the initial value of the presidio
    useEffect(() => {

        if(!presidioInitialValue?.label){
            const newValue = initialValueDoc();
            setPresidioInitialValue(newValue);
        }
        if(!subPresidioInitialValue?.label){
            const newValue = initialValueDoc();
            setSubPresidioInitialValue(newValue);
        }
   
    }, [device, templateDevice]); 

    const options = () => {
        if (template?.devicesManualOrder) {
            return addValueForDropdown(template?.devices)?.filter((x)=>x?.status!=="ARCHIVIATO");
        }
        return addValueForDropdown(template?.devices)?.sort(sortByLabel)?.filter((x)=>x?.status!=="ARCHIVIATO");
    };

    if (deviceEdit) {
        return (
            <NewDeviceField label={label}> 
               {/*  <VisDiv rules={[testing]}><button onClick={testFunction}>test field</button></VisDiv> */}
               <TestButton buttonId={"oqjksoijsdio"} consoleData={consoleData} message={"test presidio"}  />
                <FieldDropdown
                    isMulti={false}
                    isSearchable="isSearchable"
                    initialValue={substitute ? subPresidioInitialValue : presidioInitialValue}
                    //initialValue={initialValueDoc()}
                    isError={isError}
                    errorMessage={errorMessage}
                    placeHolder={undefined}
                    options={options()}
                    onChange={(value) => {
                        setChangingPresidio(true);
                        //setPresidioInitialValue(value);
                        setTemplateDevice(value);
                        const referenceTemplateField = {
                            _type: 'reference',
                            _ref: value?._id
                        };
                        const trackData = {
                            registerTemplate, 
                            device, 
                            referenceTemplateField, 
                            updatedValue: value, 
                            trackedChanges, 
                            isPresidio: true
                        };
                        trackDoc(trackData, setTrackedChanges);
                    }}
                /> 
            </NewDeviceField> 
        );
    }

    return (
        <>   
            <TestButton buttonId={"qkwdqpowdkok"} consoleData={consoleData} message={"test presidio"}  />
            <ViewLabelValueField
                label={label}
                value={initialValueDoc()?.label}
                highlight={undefined}
            />
        </>
    );
}

/**
 * Component to render a list of fields with their values.
 * The component render a dropdown with options, a text input field or a boolean button
 * according to the field type.
 * #devices
 * #devicesFields
 * 
 * @param {Object} props - The component props
 * @param {Object} props.newDoc - The document to edit
 * @param {Array} props.fieldMessages - The array of field messages
 * @param {Function} props.errorCallback - The function to call when there is an error
 * @param {Object} props.trackedChanges - The tracked changes
 * @param {Function} props.setTrackedChanges - The function to set the tracked changes
 * @param {Boolean} props.deviceEdit - If true, the component is in edit mode
 * @param {Array} props.array - The array of fields to render
 * @param {Object} props.device - The device to which the fields belong
 * @param {Array} props.state - The array of fields of the device
 * @param {Function} props.setState - The function to set the state of the device
 * @param {Object} props.collection - The collection of the device
 * @param {Object} props.currentTemplateDevice - The current template device
 * @param {Array} props.errors - The array of errors
 * @param {Boolean} props.isDuplicate - If true, the component is in duplicate mode
 * @param {Array} props.deviceNonConformities - The array of device non conformities
 * @param {Object} props.registerTemplate - The register template
 */
export const ViewEditFields = ({newDoc, fieldMessages=[], errorCallback=()=>{}, trackedChanges, setTrackedChanges=()=>{}, deviceEdit, array, device, state=[], setState, collection, currentTemplateDevice, errors, isDuplicate, deviceNonConformities=[], registerTemplate}) => 
    array && array.map?.((item, index) => {
        const {LDB} = useStateContext();
        const testing = false;

        const key = item?._id;
        const error = !Array.isArray(errors) ? [] : errors?.filter?.((y)=>y?.check)?.find?.((x)=>x?.templateId == item?._id);
        const value = matchTemplateFieldWithValue(item?._id, collection, registerTemplate, true)?.value;

        const testFunction = () => {
            console.log("jhdehdbye", {item, registerTemplate, value: matchTemplateFieldWithValue(item?._id, collection, registerTemplate, true)?.value});
        };
            
        const allNonConformities = !Array.isArray(deviceNonConformities) ? [] : deviceNonConformities?.filter?.((x)=>x?.status!=="COMPLETATO" && x?.status!=="ARCHIVIATO");

        /**
         * Checks if there is a generated non conformity associated with the field
         * @returns {Boolean} True if there is a generated non conformity associated with the field, false otherwise
         */
        const isFieldGeneratedNonConfPresent = () => {
            const fieldNonConformities = !Array.isArray(item?.nonConformities) ? [] : item?.nonConformities?.map?.((obj)=>{
                return !Array.isArray(allNonConformities) ? false : allNonConformities?.some?.((y)=>y?.nonConformity?._ref == obj?._id);
            });
            if(isDuplicate){return false;}
            if(fieldNonConformities?.some?.(x=>x)){return true;}

            const minMaxArray = [item?.maxNonConformity, item?.minNonConformity, item?.zeroNonConformity];
            const minMaxNonConformities = !Array.isArray(minMaxArray) ? [] : minMaxArray?.map?.((obj)=>{
                return !Array.isArray(allNonConformities) ? false : allNonConformities?.some?.((y)=>y?.nonConformity?._ref == obj?._ref);
            });

            if(minMaxNonConformities?.some?.(x=>x)){return true;}

            return false;
        };

        return (
           <Fragment key={key}>
            { deviceEdit ?
                <VisDiv>
                    <VisDiv rules={[testing]}><button onClick={testFunction}>test field</button></VisDiv>
                    <VisDiv rules={[!isFieldGeneratedNonConfPresent()]}>
                        <RegisterTemplateData 
                            errorCallback={errorCallback}
                            item={item} 
                            device={device}
                            currentTemplateDevice={currentTemplateDevice} 
                            deviceFields={state} 
                            setDeviceFields={setState}  
                            trackedChanges = {trackedChanges}
                            setTrackedChanges = {setTrackedChanges}
                            isError={error?.check}
                            errorMessage={error?.errorMessage}
                            registerTemplate={registerTemplate} 
                            fieldMessages={fieldMessages}    
                        /> 
                    </VisDiv>
                </VisDiv> :
                <VisDiv rules={[value, item?.status !== "ARCHIVIATO"]}>
                    <VisDiv rules={[testing]}><button onClick={testFunction}>test field</button></VisDiv>
                    <ViewLabelValueField 
                        label={item?.label?.toUpperCase()} 
                        value={value?.toUpperCase()}
                        valueType={item?.fieldType}
                    />
                </VisDiv>}
            </Fragment>  
        );
    });

/**
 * Component for viewing and editing fields
 * #devices
 * #devicesFields
 * @param {Boolean} deviceEdit Whether the component should be in edit mode
 * @param {Function} errorCallback Error callback function
 * @param {Object} item Field object being edited
 * @param {Object} device Device object being edited
 * @param {Object} state State of the field
 * @param {Function} setState Function to update the state of the field
 * @param {Object} trackedChanges Object containing the changes made to the field
 * @param {Function} setTrackedChanges Function to update the changes made to the field
 * @param {Object} collection Collection of fields
 * @param {Object} currentTemplateDevice Current template device
 * @param {Object} errors Object containing errors associated with the field
 * @param {Object} registerTemplate Register template object
 * @returns {JSX.Element} View and edit interface for a field
 */
export const ViewEditField = ({deviceEdit, errorCallback=()=>{}, item, device, state, setState, trackedChanges, setTrackedChanges=()=>{}, collection, currentTemplateDevice, errors, registerTemplate}) => {
    const testing = false;
    const testFunction = () => {
        //console.log("item:", item)
        //console.log("nonConfFound:", isFieldGeneratedNonConfPresent())
        //console.log(allNonConformities)
        //console.log("error", error)
    };
    const key = item?._id;
    const error = errors && errors.filter?.((y)=>y.check)?.find?.((x)=>x.templateId == item._id);
    const value = matchTemplateFieldWithValue(item?._id, collection)?.value;

    const userNonConformities = device?.deviceNonConformities ? device?.deviceNonConformities : [];
    const fieldNonConformities = device?.fieldDeviceNonConformities ? device?.fieldDeviceNonConformities : [];
    const allNonConformities = [...userNonConformities, ...fieldNonConformities].filter?.((x)=>x?.status!=="COMPLETATO" && x?.status!=="ARCHIVIATO");

    const isFieldGeneratedNonConfPresent = () => {
        const fieldNonConformities = item?.nonConformities?.map?.((obj)=>{
            return allNonConformities.some?.((y)=>y?.nonConformity?._ref == obj?._id);
        });

        if(fieldNonConformities?.some?.(x=>x)){return true;}

        const minMaxArray = [item?.maxNonConformity, item?.minNonConformity, item?.zeroNonConformity];
        const minMaxNonConformities = minMaxArray?.map?.((obj)=>{
            return allNonConformities.some?.((y)=>y?.nonConformity?._ref == obj?._ref);
        });

        if(minMaxNonConformities?.some?.(x=>x)){return true;}

        return false;
    };

    return (
       <Fragment key={key}>
        { deviceEdit ?
            <VisDiv>
                <VisDiv rules={[testing]}><button onClick={testFunction}>test field</button></VisDiv>
                <VisDiv rules={[!isFieldGeneratedNonConfPresent()]}>
                    <RegisterTemplateData 
                        errorCallback={errorCallback}
                        item={item} 
                        currentTemplateDevice={currentTemplateDevice} 
                        deviceFields={state} 
                        setDeviceFields={setState} 
                        trackedChanges = {trackedChanges}
                        setTrackedChanges = {setTrackedChanges}
                        isError={error?.check}
                        errorMessage={error?.errorMessage} 
                        registerTemplate={registerTemplate}  
                        device={device}     
                    /> 
                </VisDiv>
            </VisDiv> :
            <VisDiv rules={[value, item?.status !== "ARCHIVIATO"]}>
                <VisDiv rules={[testing]}><button onClick={testFunction}>test field</button></VisDiv>
                <ViewLabelValueField 
                    label={item?.label}
                    value={value}
                    valueType={item?.fieldType}
                />
            </VisDiv>}
        </Fragment>  
    );
};
